import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useDesktopLayout } from 'src/hooks/useDesktopLayout';
import { themes } from 'src/theme/theme';

interface ProducerDesktopShellProps {
  children: React.ReactNode;
}

const ProducerDesktopShell: React.FC<ProducerDesktopShellProps> = ({ children }) => {
  const { isDesktop, contentMaxWidth } = useDesktopLayout();

  if (!isDesktop) {
    return <View style={styles.mobileContainer}>{children}</View>;
  }

  return (
    <View style={styles.desktopOuter}>
      <View style={[styles.desktopInner, { maxWidth: contentMaxWidth }]}>{children}</View>
    </View>
  );
};

const styles = StyleSheet.create({
  mobileContainer: {
    flex: 1,
  },
  desktopOuter: {
    flex: 1,
    alignItems: 'center',
    backgroundColor: themes.light.gray[8],
    paddingVertical: 16,
  },
  desktopInner: {
    flex: 1,
    width: '100%',
    backgroundColor: themes.light.white[1],
    borderRadius: 12,
    shadowColor: themes.light.black[1],
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 3,
    overflow: 'hidden',
  },
});

export default ProducerDesktopShell;
